module.exports = __webpack_public_path__ + "graphics/paypal.ckh.cce927fd5b47277d478c6bc08c44cb76.svg";